// todo: styling from the mock does not fully match the current button style implementation.
//  will be updated during permafrost refactor tasks - 4/21 jm
import React, { useImperativeHandle, useRef } from 'react';
import classNames from 'classnames';
import { useButton } from '@react-aria/button';
import { useFocusRing } from '@react-aria/focus';
import { Icon, LoadingSpinner } from 'Permafrost/index';
import { StyledIconButton, StyledIconButtonLink } from './IconButton.styles';
/**
 * General utility “button with an icon” component. May also be used for links that _look_
 * like buttons, via the `isLink` property.
 *
 * The button handler must be passed in via the `onPress` property (replaces `onClick`).
 *
 * @see {@link https://react-spectrum.adobe.com/blog/building-a-button-part-1.html}
 */
export const IconButton = React.forwardRef(function (props, ref) {
    const { adjustAlignment = 0, busy, className, iconName, iconSide = 'start', id, isDisabled, isLink, label, size = 'normal', style, variant, } = props;
    const buttonRef = useRef(null);
    const anchorRef = useRef(null);
    const elementRef = isLink ? anchorRef : buttonRef;
    const { buttonProps } = useButton(Object.assign(Object.assign({}, props), { onPress: busy ? undefined : props.onPress }), elementRef);
    // Exposes select methods on the internal button ref to the parent component
    useImperativeHandle(ref, () => ({
        // Timeout places the focus at the end of the event queue to ensure the button is focusable
        focus: () => setTimeout(() => { var _a; return (_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0),
        contains: (el) => { var _a; return !!((_a = elementRef.current) === null || _a === void 0 ? void 0 : _a.contains(el)); },
    }));
    const { isFocusVisible, focusProps } = useFocusRing();
    const commonProps = Object.assign(Object.assign(Object.assign({ 'aria-disabled': busy, className: classNames(iconSide, size, variant, className, {
            'focus-visible': isFocusVisible,
            busy,
            disabled: isLink && isDisabled,
        }) }, buttonProps), focusProps), { 'data-cy': props['data-cy'], id,
        style });
    const iconElement = busy ? (React.createElement(LoadingSpinner, { size: "1em", style: {
            marginTop: `${adjustAlignment}px`,
            marginBottom: `${Math.abs(adjustAlignment)}px`,
        } })) : (React.createElement(Icon, { className: classNames({ 'right-margin': label }), name: iconName }));
    const labelElement = label ? (React.createElement("span", { style: { marginTop: `${adjustAlignment}px` } }, label)) : null;
    if (isLink && !isDisabled) {
        return (React.createElement(StyledIconButtonLink, Object.assign({}, commonProps, { ref: anchorRef, to: isLink }),
            iconElement,
            " ",
            labelElement));
    }
    return (React.createElement(StyledIconButton, Object.assign({}, commonProps, { ref: buttonRef }),
        iconElement,
        " ",
        labelElement));
});
//# sourceMappingURL=IconButton.js.map